import React from 'react'
import styled from 'styled-components'
import { Alert } from '../../../Alert'
import { Grid } from '../../../Grid'
import { Form } from 'formik'

export const Styled = styled(Form)`
  ${Grid} {
    grid-gap: 20px;
  }

  ${Alert.styled} {
    margin-bottom: 40px;
  }
`

export const Wrapper = (props: React.FormHTMLAttributes<HTMLFormElement>) => {
  return (
    <Styled
      {...props}
      noValidate
    />
  )
}
